import { useEffect, useState } from "react";
import { checkDevice } from "../utils/helper";

export function useDeviceType() {
  const [currentDevice, setCurrentDevice] = useState("");
  useEffect(() => {
    checkDevice(window.innerWidth, setCurrentDevice);
    window.addEventListener("resize", () => {
      checkDevice(window.innerWidth, setCurrentDevice);
    });
    return () => {
      window.removeEventListener(
        "resize",
        checkDevice(window.innerWidth, setCurrentDevice)
      );
    };
    // eslint-disable-next-line
  }, []);
  return currentDevice;
}
